import React from 'react'
import { AdvancedFilter } from 'components/Filter/AdvancedFilter'
import { UsefulLifeMain } from './UsefulLifeMain'
import { UsefulLifeDetail } from './UsefulLifeDetail/UsefulLifeDetail'
import { components } from 'knockout'
import { UsefulLifeForm } from './UsefulLifeForm/UsefulLifeForm'

const usefulLifeRoutes = [
  /* -------------------------------------------- */
  /*                ADVANCED FILTER               */
  /* -------------------------------------------- */

  {
    props: {
      exact: true,
      path: '/fixed-assets/:CompanyID/assets-change/useful-life/filter',
    },
    component: (
      <AdvancedFilter
        mode="assets-change"
        app="fixed-assets"
        hasStatus
        hasDocDate
        hasDateRange
      />
    ),
  },

  /* -------------------------------------------- */
  /*                     MAIN                     */
  /* -------------------------------------------- */

  {
    props: {
      exact: true,
      path: '/fixed-assets/:CompanyID/assets-change/useful-life',
    },
    component: <UsefulLifeMain />,
  },

  /* -------------------------------------------- */
  /*                     FORM                     */
  /* -------------------------------------------- */

  {
    props: {
      exact: true,
      path: '/fixed-assets/:CompanyID/assets-change/useful-life/add',
    },
    component: <UsefulLifeForm formMode="add" type="ASSETS_REGISTRATION" />,
  },
  {
    props: {
      exact: true,
      path:
        '/fixed-assets/:CompanyID/assets-change/useful-life/:UsefulLifeID/edit',
    },
    component: <UsefulLifeForm formMode="edit" />,
  },
  {
    props: {
      exact: true,
      path:
        '/fixed-assets/:CompanyID/assets-change/useful-life/:UsefulLifeID/approve-reject',
    },
    component: <UsefulLifeForm formMode="approve-reject" />,
  },
  {
    props: {
      exact: true,
      path:
        '/fixed-assets/:CompanyID/assets-change/useful-life/:UsefulLifeID/resubmit',
    },
    component: <UsefulLifeForm formMode="resubmit" />,
  },

  /* -------------------------------------------- */
  /*                    DETAIL                    */
  /* -------------------------------------------- */

  {
    props: {
      exact: true,
      path:
        '/fixed-assets/:CompanyID/assets-change/useful-life/:UsefulLifeID/detail',
    },
    component: <UsefulLifeDetail />,
  },
]

export default usefulLifeRoutes
